// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { ChartSection } from '../chart-section/ChartSection'
import auditLogIcon from '../../../../images/common/auditLog.png'
import { AUDIT_LOG, NO_AUDIT_LOG } from '../../Constants'
import { getPatientAuditLogs } from '../../../../store/charts/ChartsThunk'
import './AuditLogs.scss'
import AuditLogRow from './AuditLogRow'
import { useAuditLogs } from './useAuditLog'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const AuditLogs = ({ userTimeZone }) => {
  const dispatch = useDispatch()
  const { search } = useLocation()
  const params = new URLSearchParams(search)
  const id = params.get('id')
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const loading = useSelector((state) => state.chartsReducer.loading)

  const { filteredAuditLogs, getLogFilter } = useAuditLogs({ id })
  const needAuditLogDataRequest = useRef(true)
  const [isCollapsed, setCollapsed] = useState(true)

  const toggleSection = () => {
    if (needAuditLogDataRequest.current) {
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      dispatch(getPatientAuditLogs(id))
      needAuditLogDataRequest.current = false
    }

    setCollapsed((state) => !state)
  }

  return (
    // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
    <ChartSection
      className='audit-log-section'
      title={AUDIT_LOG}
      icon={auditLogIcon}
      iconAltText={AUDIT_LOG}
      isCollapsed={isCollapsed}
      setIsCollapsed={toggleSection}
      emptyText={!loading || (!filteredAuditLogs?.length && NO_AUDIT_LOG)}
      userTimeZone={userTimeZone}
      isWithoutLastUpdated
      isWithoutSeparateLine
      isShowEmptyContent={!filteredAuditLogs?.length}>
      {getLogFilter()}
      {filteredAuditLogs?.length ?
        <table>
          <thead>
            <tr className='audit-log-table-head-row'>
              <th className='audit-log-table-head audit-log-name'>
                <div className='audit-log-name-title'>User</div>
              </th>
              <th className='audit-log-table-head audit-log-date'>
                <div className='audit-log-date-title'>Date & time</div>
              </th>
              <th className='audit-log-table-head audit-log-message'>
                <div className='audit-log-message-title'>Message</div>
              </th>
            </tr>
          </thead>
          <tbody>
            <AuditLogRow auditLogs={filteredAuditLogs} userTimeZone={userTimeZone} />
          </tbody>
        </table>
      : null}
    </ChartSection>
  )
}
